import { compose, replace, toUpper } from 'lodash/fp'

export const dateFormat = compose(
  compose(
    replace(/^([dD]{1})$/, 'DD'),
    replace(/^([dD]{1})(\W)/, 'DD$2'),
    replace(/(\W)([dD]{1})$/, '$1DD'),
    replace(/(\W)([dD]{1})(\W)/, '$1DD$3'),
  ),
  compose(
    replace(/^([mM]{1})$/, 'MM'),
    replace(/^([mM]{1})(\W)/, 'MM$2'),
    replace(/(\W)([mM]{1})$/, '$1MM'),
    replace(/(\W)([mM]{1})(\W)/, '$1MM$3'),
  ),
  toUpper,
)

export const timeFormat = compose(
  replace('G', 'hh'),
  replace('GG', 'HH'),
)

export default function(date: string, time: string): string {
  return [dateFormat(date), timeFormat(time)].join(' ').trim()
}
